<div class="youtube-container" *ngIf="id?.length === 11">
  <youtube-player [videoId]="id"></youtube-player>
</div>
